export default __webpack_public_path__ + "static/images/appstore-badge-ed7156873fc750291b014544ba35479b.png";